import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import Text from '../../../../shared/Text';
import Select from '../../../../shared/Select/Select.jsx';

export const AudienceFilter = ({
  audiences,
  audienceFilter,
  setAudienceFilter,
}) => {
  const { t } = useTranslation('campaigns');

  const onChange = option => {
    const { value } = option;

    if (value === '') {
      setAudienceFilter(null);
    } else if (value === 'all') {
      setAudienceFilter('all');
    } else {
      setAudienceFilter(parseInt(value, 10));
    }
  };

  const optionsToSelect = [
    { value: 'all', label: t('preview.allAudience') },
    { value: '', label: t('preview.noAudience') },
    ...audiences.map(audience => ({
      value: audience.id,
      label: audience.name,
    })),
  ];

  return (
    <Container>
      <HeaderText variant="h5">{t('preview.previewHeader')}</HeaderText>

      <AudienceSelect>
        <Select
          components={{
            IndicatorSeparator: () => null,
          }}
          options={optionsToSelect}
          value={
            audienceFilter === null
              ? optionsToSelect.find(option => option.value === '')
              : optionsToSelect.find(option => option.value === audienceFilter)
          }
          onChange={onChange}
          isSearchable={false}
          name="audience"
          id="audienceId"
        />
      </AudienceSelect>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: row;
  text-align: center;
  align-items: center;
  gap: 16px;
  & span strong {
    font-weight: 500;
  }
`;

const HeaderText = styled(Text)`
  white-space: nowrap;
`;

const AudienceSelect = styled.div`
  width: 350px;
  &:last-of-type {
    margin: 0;
  }
`;
